import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import Input from 'components/fulcrum/input/Input'
import { Creatable } from 'react-select'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  IconButton
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import styles from './styles.scss'
import { TYPE, VENDOR, PART_NUMBER, DETAILS } from './constant'
import _ from 'lodash'



class PowerMonitorIc extends Component {

  handleChange = (index, type, val) => {
    this.props.onChange(index, type, val)
  };

  handleAdd = () => {
    this.props.addValueAction()
  }

  handleRemove(index) {
    return () => this.props.onRemove(index)
  }

  getTableHead = (tableHeadContent) =>  (
    <TableHead>
        {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
  )


  typeSrc = (types, typeVal) => {
    const src =  (typeVal && types.filter(s => s.value === typeVal).length === 0) ? types.concat([{label: typeVal, value: typeVal}]) : types
    return src
  }

  vendorSrc = (vendors, vendorVal) => {
    const src = (vendorVal && vendors.filter(s => s.value === vendorVal).length === 0) ? vendors.concat([{label: vendorVal, value: vendorVal}]) : vendors;
    return src
  }

  partNumberSrc = (partNumbers, partNumberVal) => {
    const src = (partNumberVal && partNumbers.filter(s => s.value === partNumberVal).length === 0) ? partNumbers.concat([{label: partNumberVal, value: partNumberVal}]) : partNumbers;
    return src
  }

  getIconButton = (idx, values) => {
    if (values.length == 1){
      return (
        <IconButton icon='delete' onClick={this.handleRemove(idx)} primary disabled />
        )
    }
    else {
      return (
        <IconButton icon='delete' onClick={this.handleRemove(idx)} primary />
        )
    }
    
  }

  getRows = () => {
    const { values, types, vendors, partNumbers } = this.props
    const mapIndexed = R.addIndex(R.map);
    return(
        mapIndexed((rowContent, idx) => (
          
            <TableRow key={idx}>
                    <TableCell key={'type'}>
                      <Creatable className={styles.creatable} value={rowContent['type']} clearable={false} options={this.typeSrc(types, rowContent['type'])} multi={false} onChange={this.handleChange.bind(this, idx, 'type')}/>
                    </TableCell>
                    <TableCell key={'vendor'}>
                      <Creatable className={styles.creatable} value={rowContent['vendor']} clearable={false} options={this.vendorSrc(vendors, rowContent['vendor'])} multi={false} onChange={this.handleChange.bind(this, idx, 'vendor')}/>
                    </TableCell>
                    <TableCell key={'partNumber'}>
                      <Creatable className={styles.creatable} value={rowContent['partNumber']} clearable={false} options={this.partNumberSrc(partNumbers, rowContent['partNumber'])} multi={false} onChange={this.handleChange.bind(this, idx, 'partNumber')}/>
                    </TableCell>
                    <TableCell key={'details'}>
                      <Input value={rowContent['details']|| ""} onChange={this.handleChange.bind(this, idx, 'details')} />
                    </TableCell>
                    <TableCell 
                      styleName="deleteBtn"
                      theme={styles}
                      key={"delete"}
                    >
                      {this.getIconButton(idx, values)}
                    </TableCell>
            </TableRow>
          
        ), values)
    )
  }
  

  render() {
    const tableHeadContent = {
      [TYPE]: (<TableCell key={0}>Type</TableCell>),
      [VENDOR]: (<TableCell key={1}>Vendor</TableCell>),
      [PART_NUMBER]: (<TableCell key={2}>Part Number</TableCell>),
      [DETAILS]: (<TableCell key={3}>Details</TableCell>),
    }
    
    return (
      <Fragment >
        <div>
          <span styleName='configTitle'>Power Monitor IC</span>
        </div>
      <Table selectable={false} className={styles.table}>
        {this.getTableHead(tableHeadContent)}        
        {this.getRows()}
      </Table>
      <Button
        icon='add'
        label='Add Power Monitor IC'
        flat
        primary
        onClick={() => this.props.addValueAction()}
        styleName="universeAddBtn"
        theme={styles}
      />

    </Fragment>
    )
  }
}

export default CSSModules(PowerMonitorIc, styles)
